import maintenanceAnimation from "@client/animations/maintenance.json";
import * as graphics from "@client/app/graphics";
import {Lottie} from "@client/hacks";
import * as router from "@client/router";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import * as React from "react";

import {Shell} from "./PlanOnboarding";

export const Maintenance = router.Maintenance.withHooks(() => ({}))
    .withIndex(() => (
        <Shell>
            <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center text-pretty">
                <graphics.Logo className="h-10" />
                <Lottie
                    animationData={maintenanceAnimation}
                    loop={true}
                    className="size-48"
                />
                <div className="space-y-2">
                    <p className="text-3xl font-medium">We'll be right back</p>
                    <p className="text-lg text-stone-800">
                        Joy is currently undergoing maintenance.
                    </p>
                </div>
                <button
                    className="mt-4 flex items-center gap-1.5 rounded-3xl bg-indigo-600 px-6 py-3 font-medium text-white transition-colors hover:bg-indigo-700"
                    onClick={() => {
                        window.location.href = "/";
                    }}
                >
                    Try again
                    <ArrowPathIcon className="size-5" />
                </button>
            </div>
        </Shell>
    ))
    .withActions(() => [])
    .withOptions(() => ({title: "Maintenance", scene: {kind: "EMPTY"}}));
